export default __webpack_public_path__ + "static/media/background.14a00095.png";